import type { FaireProductEntity } from "../../entity_types/product";

export const p_m3kaxjr6s2: FaireProductEntity = {
  token: "p_m3kaxjr6s2",
  type: "product",
  name: "Winter Hearth Soy Candle | 9 oz Amber Apothecary Jar",
  brandName: "Prairie Fire Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/5dd65e4fa73f6aadd4f65495e7ac88d44411b418c7a2a7a121f19ddb91d6fc8e.jpeg",
  priceDollars: 7.99,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/94d6db20eb4d9b50153b0e11a64b8c8f58c0dd3b820e189ee1a35f7171e46cbd.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
